import { appOptions } from "./appOptions";
import { client } from "./MksapAPI/client.gen";
import { getRequestAuthHeaders } from "./utils/getAjaxRequestOptions";
import { possiblyInterceptRequestForDebugging } from "./utils/makeAjaxPromise";

// Configure @hey-api/openapi-ts API client
client.setConfig({
	baseUrl: appOptions.ajaxPrefix,
});

// Add request interceptor for debugging and auth headers
client.interceptors.request.use(async (request, options) => {
	await possiblyInterceptRequestForDebugging({
		url: options.url,
		method: options.method,
	});

	const authHeaders = getRequestAuthHeaders();
	Object.entries(authHeaders).forEach(([key, value]) => {
		request.headers.set(key, value);
	});

	return request;
});
